<ng-container *ngIf="options$ | async as options">
  <ul
    class="list-group list-group-borderless list-group-condensed ms-5"
    [ngStyle]="{ maxHeight: active ? 40 * numberOfOptions + 'px' : 0 }"
  >
    <li
      role="button"
      *ngFor="let option of options"
      class="list-group-item list-group-item-action border-0"
      style="cursor: pointer; min-height: auto"
      [routerLink]="option.url"
      routerLinkActive="active"
      [attr.data-tour-poi]="option.url"
    >
      {{ option.displayName }}
    </li>
  </ul>
</ng-container>
